<template>
    <div class="habit-page">
        <div class="row mt-2">
            <div class="col-lg-11 col-11 mx-auto">

                    <div class="list-group-item mb-2">
                        <div class="row mt-2 d-flex justify-content-center" v-if="myKSSDetails.length>0">
                            <div class="col-md-3 content-left">
                                <select  style="width:20em;margin-bottom:2px;" class="form-control" :hidden="myKSSDetails.length <1"
                                            @change="displaySelectedKSS()" v-model="selKSSID">
                                    <option value="">Please Select</option>
                                    <option
                                        v-for="(kss, id) in myKSSDetails"
                                        :key="id"
                                        :value="kss.id"
                                    >{{ kss.name }}</option>
                                </select>
                            </div>
                        </div>


                        <div class="row">
                            <div v-if="selKSSID !=''">

                                <!--Start-->
                                <div class="content-box-gray card" >
                                    <div class="goal-head" >
                                        <b>My Goal:</b> {{goal_kss_name}}<br/> <b>My Why: </b>{{ goal_kss_desc }}
                                        <br/><span style="font-size:small;color:rgb(253, 253, 253);"><b>Review Time: {{ elapsedTime }}  seconds.</b><br/>(Need to spend {{elapsedTimeTarget}} seconds)</span>
                                    </div>
                                <div class="card p-2 m-2" >
                                    <div class="periods-head">Me: stuck with my Past-Self</div>
                                    <div class="row justify-content-between" >
                                        <div class="col-4">
                                             <h6  class="component-head txt-primary bg-secondary">Goal-Defeating<br/> Actions/Inactions </h6>
                                            <div>
                                                <ul>
                                                    <li v-for="(action, index) in past_actions" :key="index" >
                                                        {{action}}
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="col-4">
                                             <h6 class="component-head txt-primary bg-secondary">Hidden Committments<br/> to my Past-Self</h6>
                                             <div>
                                                <ul>
                                                    <li v-for="(committment, index) in past_committments" :key="index" >
                                                        {{committment}}
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="col-4">
                                             <h6 class="component-head txt-primary bg-secondary">Limiting <br/>Beliefs/Assumptions</h6>
                                            <div>
                                                <ul>
                                                    <li v-for="(belief, index) in past_beliefs" :key="index" >
                                                        {{belief}}
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
</div>
                                    <div class="card p-2 m-2" >
                                    <div class="periods-head">Me: aligned with my Future-Self</div>
                                    <div class="row justify-content-between" >
                                        <div class="col-4">
                                             <h6  class="component-head txt-primary bg-secondary">Goal-Supporting<br/> Actions/Inactions </h6>
                                            <div>
                                                <ul>
                                                    <li v-for="(action, index) in new_actions" :key="index" >
                                                        {{action}}
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="col-4">
                                             <h6 class="component-head txt-primary bg-secondary">New Committments<br/> to my Future-Self</h6>
                                             <div>
                                                <ul>
                                                    <li v-for="(committment, index) in new_committments" :key="index" >
                                                        {{committment}}
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="col-4">
                                             <h6 class="component-head txt-primary bg-secondary">Empowering <br/>Beliefs/Assumptions</h6>
                                            <div>
                                                <ul>
                                                    <li v-for="(belief, index) in new_beliefs" :key="index" >
                                                        {{belief}}
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
</div>
                                </div>
<!--End-->




                                </div>

                        </div>
                    </div>

            </div>
        </div>
    </div>
</template>

<script>

import axios from 'axios';
import Swal from 'sweetalert2';
var _ = require('lodash');

export default {
    components:{
     },
    name: "KSSDisplaySelection",
    data() {
        return {
            token: document.head.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            loading: false,
            errors: {
                header: '',
                hc_add: '',
            },
            userData:'',
            myKSSDetails:'',
            selKSSID: '',
            selKSSData: '',
            past_actions:'',
            new_actions:'',
            past_committments:'',
            new_committments: '',
            past_beliefs:'',
            new_beliefs: '',
            goal_kss_name:'',
            goal_kss_desc:'',
            elapsedTimeTarget: 90,
            elapsedTime:0,
            startTime:'',
            timerInterval:'',
            kssCommittmentsData:'',
            kssBeliefsData:'',
            kssActionsData:'',
      }
    },

    props: {

    },
    mounted() {
        this.getMyKSSDetailsData();
    },
    beforeDestroy() {
        this.stopTimer();
    },

    methods: {
        startTimer() {
            this.timerInterval = setInterval(() => {
                const currentTime = new Date();
                this.elapsedTime = Math.floor(
                    (currentTime - this.startTime) / 1000
                );
            }, 1000);
            console.error(this.elapsedTime);
            if(this.elapsedTime >= this.elapsedTimeTarget) {
                console.error('Review  time achieved for ' + this.userinfo.id);
                this.recordKSSReview();
                this.reviewMessage ="Great job!";
                this.stopTimer();
            }
        },
        stopTimer() {
            clearInterval(this.timerInterval);
        },
        recordKSSReview() {
            console.error('Recording review for ' + this.userData.id);
             axios.post('/eliminatess/review/save', {
                user_id:this.userData.id,
                kill_selfsabotage_id:this.selKSSData.id
            })
            .then(res => {
                this.reviewMessage = res.data.message;
                this.stopTimer();
                console.error(res.data.message);
            })
            .catch(err => {               ;
                console.error(err);
            })
            .finally(()=> {
                  this.updateToast(this.reviewMessage, 4000);
            });
        },

       updateToast(message, timer = 2000, icon='success') {
            const Toast = Swal.mixin({
                position: 'center',
                width: 500,
                showConfirmButton: true,
            });
            Toast.fire({
                icon: icon,
                title: message
            });
        },
        displaySelectedKSS() {
            this.selKSSData = this.getKSSData(this.selKSSID);
            this.setup2DisplayKSS();
            this.startTimer();

        },
        getMyKSSDetailsData() {
             console.log("getMyKSSDetailsData: " );
            axios.get('/eliminatess/viewinsert')
            .then(res => {
                this.loading = false;
                this.success = true;
                this.message = res.data.message;
                this.userData =JSON.parse(res.data.userdata);
                this.myKSSDetails =JSON.parse(res.data.kss);
                // console.error(res.data.message);
            })
            .catch(err => {
                // this.loading = false;
                // this.failure = true;
                console.error(err);
            })
            .finally(()=> {
                this.message = '';
            });
        },

        getKSSData(habit_id) {
            console.log("Looking for KSS with id: " + habit_id);
            var retVal = '';
            this.myKSSDetails.forEach((aHabit)=>{
                // console.log(aHabit.name + aHabit.id);
                if(aHabit.id == habit_id)  {
                    console.log("Found KSS: " + aHabit.name);
                    retVal =  aHabit;
                }
            });
            return retVal;
        },
        splitDataIntoFormerNew(){
            this.past_actions = this.getArrayFromDescription(this.kssActionsData, 'FORMER');
            this.new_actions = this.getArrayFromDescription(this.kssActionsData, 'NEW');
            this.past_committments = this.getArrayFromDescription(this.kssCommittmentsData, 'FORMER');
            this.new_committments = this.getArrayFromDescription(this.kssCommittmentsData, 'NEW');
            this.past_beliefs = this.getArrayFromDescription(this.kssBeliefsData, 'FORMER');
            this.new_beliefs = this.getArrayFromDescription(this.kssBeliefsData, 'NEW');
        },
        getArrayFromDescription(componentArr, FORMER_or_NEW){
            var arr = [];
            var descArr = [];
            componentArr.forEach((obj) => {
                if(obj.type == FORMER_or_NEW) {
                    descArr = JSON.parse(obj.description);
                    // console.log(obj.type);
                    for (var i = 0; i < descArr.length; i++) {
                        var entry = descArr[i];
                        // console.log(entry);
                        arr.push(entry);
                    }
                }
            });
        return arr;
        },

        setup2DisplayKSS(){
            this.selKSSData = this.getKSSData(this.selKSSID);
            this.goal_kss_name = this.selKSSData.name;
            this.goal_kss_desc = this.selKSSData.description;
            // console.log(this.currentKSSdata);
            this.kssCommittmentsData = this.selKSSData.committments;
            this.kssBeliefsData = this.selKSSData.beliefs;
            this.kssActionsData = this.selKSSData.actions;
            this.splitDataIntoFormerNew();
            // this.getArrayFromDescription('FORMER');
            this.startTime = new Date();
            this.startTimer();
        },

    },
    watch: {
        elapsedTime(newValue) {
            if (newValue === this.elapsedTimeTarget) {
            this.recordKSSReview();
            }
        }
    },
}
</script>

<style scoped>
.content-box-gray .content {
    overflow: wrap;
    padding: 10px;
    font-size: 1.2em;
    /* border-bottom-left-radius: 1em;
    border-bottom-right-radius: 1em; */
    border: 1px solid rgb(15, 9, 9);
    color: #212c3e;
}
.content-box-gray .title {
    height:4em;
    line-height:1.6em;
    border-top-left-radius: .5em;
    border-top-right-radius: .5em;
     background:#1a794b;
    font-size:.75em;
    /* font-weight:bold; */
    font-family:verdana;
    display:block;
    color:white;
    display:block;
    padding:auto;
    border: 1px solid gray;
    border-bottom:none;
}


.overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation: fadeOut 5s forwards;
}

@keyframes fadeOut {
  0% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    visibility: hidden;
  }
}

#yayOverlay {
  width: 40vw;
  height: 40vh;
  border: 2px solid #000;
  border-radius: 4px;
  box-shadow: #555 4px 4px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;

}

#yayOverlay.h5 {
  max-width: 100%;
  margin: 0;
  padding: 10px;
  word-wrap: break-word;
}
#yayOverlay.img {
  max-width: 100%;
  max-height: 80%;
  object-fit: contain;
}

@media (max-width: 768px) {
    #yayOverlay.card {
        width: 80vw;
        height: 60vh;
        /* Adjust dimensions and other styles for mobile */
    }
    #yayOverlay.img {
    width: 80%;
    object-fit: contain;
    }
}
.goal-head{
background: #212c3e;
color: #d6a30a;
font-size:small;
text-align:center;
word-wrap: break-word;
  @media (max-width: 768px) {
       font-size:small;
    }
}
.periods-head{
background: #d6a30a;
color: #0f0f0f;
font-size:small;
text-align:center;
word-wrap: break-word;
  @media (max-width: 768px) {
       font-size:small;
    }
}
.component-head{
background: #687b9a;
color: #2003fc;
font-size:small;
text-align:center;
word-wrap: break-word;
  @media (max-width: 768px) {
       font-size:small;
    }
}

ul{
list-style-type: none; /* Remove bullets */
  padding: 0; /* Remove padding */
  margin: 0; /* Remove margins */
    text-align: left;
    font-size: small;
}
.card{
    border:#111 1px solid;
}


</style>
